var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8957",
    fill: "none",
    stroke: "#707070",
    d: "M0 0H32V32H0z",
    transform: "translate(468 421)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-5{fillRule:evenodd;fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_58098",
    clipPath: "url(#clip-path)",
    transform: "translate(-468 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_213734_card_cash_checkout_mastercard_online_shopping_icon",
    transform: "translate(427.739 299.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61019",
    transform: "translate(42.673 130.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154290",
    fill: "#fab31e",
    fillRule: "evenodd",
    d: "M217.792 144a7.858 7.858 0 0 0 5.333 2.075 8.007 8.007 0 0 0 0-16.013 7.858 7.858 0 0 0-5.333 2.076 8.012 8.012 0 0 0 0 11.862z",
    transform: "translate(-204.487 -130.063)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154291",
    fill: "#e40520",
    fillRule: "evenodd",
    d: "M58.549 137.226c-.027-.289-.082-.564-.138-.852h-4.865a8.334 8.334 0 0 1 .22-.839h4.412c-.1-.288-.206-.577-.33-.852h-3.739c.137-.288.289-.577.454-.852h2.817a7.19 7.19 0 0 0-.6-.838h-1.613a7.948 7.948 0 0 1 .811-.852 8.007 8.007 0 1 0 0 11.862 7.668 7.668 0 0 0 .8-.839h-1.611a9.483 9.483 0 0 1-.6-.852h2.813a6.378 6.378 0 0 0 .467-.852h-3.738a8.9 8.9 0 0 1-.344-.839h4.412a8.644 8.644 0 0 0 .233-.852 7.675 7.675 0 0 0 .179-1.691c0-.289-.014-.577-.041-.852z",
    transform: "translate(-42.673 -130.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154292",
    d: "M455.15 285.5a.25.25 0 0 1 .247-.261.253.253 0 0 1 .261.261.261.261 0 0 1-.261.261.259.259 0 0 1-.247-.261zm.247.192a.193.193 0 1 0 0-.385.192.192 0 0 0 0 .385zm-.027-.082h-.055v-.22h.151c.027.014.027.041.027.069a.074.074 0 0 1-.041.055l.055.1h-.069l-.028-.082h-.041v-.041h.027c.014 0 .028 0 .028-.014s.014-.014.014-.027a.013.013 0 0 0-.014-.014c0-.014-.014 0-.028 0h-.027v.179z",
    className: "cls-5",
    transform: "translate(-429.612 -275.636)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154301",
    d: "M298.655 226.619l-.151.88a1.654 1.654 0 0 0-.77-.22c-.646 0-1.1.632-1.1 1.526 0 .618.3.99.811.99a1.682 1.682 0 0 0 .728-.206l-.151.921a2.863 2.863 0 0 1-.756.124c-.935 0-1.512-.674-1.512-1.76 0-1.443.8-2.46 1.938-2.46a1.7 1.7 0 0 1 .4.041l.344.082c.11.041.137.055.22.082z",
    className: "cls-5",
    transform: "translate(-280.085 -220.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154302",
    d: "M266.932 239.509h-.083c-.289 0-.454.137-.715.536l.082-.509h-.783l-.536 3.3h.866c.316-2.021.4-2.364.811-2.364h.055a3.454 3.454 0 0 1 .33-.948l-.027-.014z",
    className: "cls-5",
    transform: "translate(-251.139 -232.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154303",
    d: "M197.6 235.712a1.783 1.783 0 0 1-.618.11.636.636 0 0 1-.687-.728 2.264 2.264 0 0 1 .027-.289l.055-.33.041-.261.371-2.254h.852l-.1.495h.44l-.11.811h-.44l-.233 1.374a.512.512 0 0 0-.014.138c0 .165.082.234.289.234a.573.573 0 0 0 .234-.027l-.11.728z",
    className: "cls-5",
    transform: "translate(-186.786 -225.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154304",
    d: "M158.887 239.954a.963.963 0 0 0 .646.921c.357.165.412.22.412.357 0 .206-.151.3-.495.3a2.572 2.572 0 0 1-.77-.124l-.124.756.041.014.151.027a.905.905 0 0 0 .234.027 3.188 3.188 0 0 0 .467.027c.907 0 1.333-.344 1.333-1.1a.914.914 0 0 0-.6-.921c-.371-.165-.412-.206-.412-.357 0-.179.151-.261.426-.261a5.37 5.37 0 0 1 .618.041l.124-.756a4.978 4.978 0 0 0-.756-.069c-.962 0-1.306.509-1.292 1.113z",
    className: "cls-5",
    transform: "translate(-151.382 -232.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154305",
    d: "M409.366 231.8h-.811l.041-.316a1.028 1.028 0 0 1-.8.357c-.632 0-1.045-.536-1.045-1.361 0-1.1.646-2.034 1.4-2.034a.987.987 0 0 1 .825.454l.192-1.155h.852l-.66 4.055zm-1.265-.77c.4 0 .674-.468.674-1.113 0-.426-.151-.646-.454-.646-.385 0-.674.454-.674 1.1q0 .66.454.66z",
    className: "cls-5",
    transform: "translate(-384.212 -221.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154306",
    d: "M224.4 241.933a2.813 2.813 0 0 1-.894.137 1.309 1.309 0 0 1-1.457-1.484c0-1.127.632-1.966 1.5-1.966a1.1 1.1 0 0 1 1.168 1.2 3.33 3.33 0 0 1-.11.825h-1.7a.267.267 0 0 0-.014.1c0 .385.261.578.756.578a1.89 1.89 0 0 0 .894-.206l-.138.825zm-.481-1.966v-.167a.38.38 0 0 0-.412-.426c-.275 0-.467.206-.55.591z",
    className: "cls-5",
    transform: "translate(-210.945 -231.899)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154307",
    d: "M58.556 231.8H57.7l.495-3.12-1.113 3.12h-.591l-.069-3.093-.522 3.093h-.8l.674-4.055h1.237l.041 2.515.825-2.515h1.353z",
    className: "cls-5",
    transform: "translate(-54.336 -221.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154308",
    d: "M118.582 240.738c-.082 0-.124-.014-.192-.014-.481 0-.729.179-.729.509a.29.29 0 0 0 .3.33c.357 0 .6-.33.619-.825zm.632 1.471h-.714l.014-.344a1.071 1.071 0 0 1-.907.4.8.8 0 0 1-.783-.894c0-.811.55-1.278 1.512-1.278.1 0 .22.014.357.027a.693.693 0 0 0 .027-.206c0-.22-.151-.3-.55-.3a2.835 2.835 0 0 0-.715.082l-.124.041-.082.014.124-.742a3.456 3.456 0 0 1 1.031-.165c.742 0 1.141.33 1.141.962a4.165 4.165 0 0 1-.069.66l-.193 1.168-.027.206-.014.165-.014.124-.014.083z",
    className: "cls-5",
    transform: "translate(-112.232 -232.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154309",
    d: "M338.364 240.738c-.1 0-.137-.014-.192-.014-.495 0-.742.179-.742.509a.3.3 0 0 0 .316.33c.344 0 .6-.33.618-.825zm.632 1.471h-.715l.014-.344a1.071 1.071 0 0 1-.907.4.8.8 0 0 1-.783-.894c0-.811.55-1.278 1.512-1.278.1 0 .22.014.344.027a.873.873 0 0 0 .041-.206c0-.22-.151-.3-.55-.3a2.951 2.951 0 0 0-.728.082l-.11.041-.082.014.124-.742a3.456 3.456 0 0 1 1.031-.165c.742 0 1.127.33 1.127.962a2.944 2.944 0 0 1-.069.66l-.179 1.168-.028.206-.027.165-.014.124v.083z",
    className: "cls-5",
    transform: "translate(-318.406 -232.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154310",
    d: "M381.913 239.509h-.082c-.289 0-.454.137-.715.536l.082-.509h-.783l-.522 3.3h.852c.316-2.021.4-2.364.811-2.364h.055a3.457 3.457 0 0 1 .33-.948l-.028-.014z",
    className: "cls-5",
    transform: "translate(-359.013 -232.733)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.bb5100cb91ba240ddf98a984490c6e72.svg";
export { ForwardRef as ReactComponent };